import React from 'react';
import PageHero from 'components/PageHero';

const iconStroke = {
    fill: 'none',
    stroke: '#312f2e',
    strokeWidth: 1.75,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    width: 26,
    height: 26,
    viewBox: '0 0 24 24',
    'aria-hidden': true
};

const icons: Record<string, React.ReactNode> = {
    oms: (
        <svg {...iconStroke}>
            <path d="M21 8H3l2-4h14l2 4z" />
            <path d="M3 8v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8" />
            <path d="M12 8v12" />
        </svg>
    ),
    aftersales: (
        <svg {...iconStroke}>
            <path d="M3 18v-2a4 4 0 0 1 4-4h1" />
            <path d="M21 18v-2a4 4 0 0 0-4-4h-1" />
            <circle cx="7" cy="18" r="3" />
            <circle cx="17" cy="18" r="3" />
            <path d="M7 11V9a5 5 0 0 1 10 0v2" />
        </svg>
    ),
    hybrid: (
        <svg {...iconStroke}>
            <path d="M3 9 12 3l9 6" />
            <path d="M5 10v10h14V10" />
            <path d="M9 20v-6h6v6" />
        </svg>
    ),
    scheduling: (
        <svg {...iconStroke}>
            <rect x="3" y="5" width="18" height="16" rx="2" />
            <path d="M3 10h18" />
            <path d="M8 3v4" />
            <path d="M16 3v4" />
            <path d="M8 14h.01" />
            <path d="M12 14h.01" />
            <path d="M16 14h.01" />
        </svg>
    ),
    tickets: (
        <svg {...iconStroke}>
            <path d="M4 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 1 0 0 4v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 1 0 0-4V8z" />
            <path d="M12 8v8" />
        </svg>
    ),
    crm: (
        <svg {...iconStroke}>
            <circle cx="9" cy="8" r="3" />
            <path d="M3 19a6 6 0 0 1 12 0" />
            <circle cx="17" cy="9" r="2.5" />
            <path d="M16.5 19a5 5 0 0 1 4.5-5" />
        </svg>
    ),
    estimator: (
        <svg {...iconStroke}>
            <rect x="5" y="3" width="14" height="18" rx="2" />
            <path d="M8 7h8" />
            <path d="M8 11h.01" />
            <path d="M12 11h.01" />
            <path d="M16 11h.01" />
            <path d="M8 15h.01" />
            <path d="M12 15h.01" />
            <path d="M16 15h.01" />
        </svg>
    ),
    directory: (
        <svg {...iconStroke}>
            <path d="M6 4h12a2 2 0 0 1 2 2v14l-8-3-8 3V6a2 2 0 0 1 2-2z" />
            <circle cx="12" cy="10" r="2" />
            <path d="M9 15a3 3 0 0 1 6 0" />
        </svg>
    ),
    dam: (
        <svg {...iconStroke}>
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <circle cx="8.5" cy="10" r="1.5" />
            <path d="m21 16-5.5-5.5L7 19" />
        </svg>
    )
};

const solutions = [
    { href: '/solutions/oms', icon: 'oms', label: 'OMS - Order Management System' },
    { href: '/solutions/after-sales', icon: 'aftersales', label: 'Gestione post-vendita' },
    { href: '/solutions/hybrid-commerce', icon: 'hybrid', label: 'Soluzioni Hybrid Commerce' },
    { href: '/solutions/scheduling', icon: 'scheduling', label: 'Pianificatore attività' },
    { href: '/solutions/support-tickets', icon: 'tickets', label: 'Gestione ticket assistenza' },
    { href: '/solutions/crm', icon: 'crm', label: 'CRM per aziende B2B' },
    { href: '/solutions/estimator', icon: 'estimator', label: 'Preventivatore software' },
    { href: '/solutions/company-directory', icon: 'directory', label: 'Rubrica aziendale contatti' },
    { href: '/solutions/dam', icon: 'dam', label: 'DAM - Gestione asset digitali' }
];

let Solutions = () => {
    return (
        <>
            <PageHero
                eyebrow="Soluzioni software"
                title="Soluzioni custom designed"
                lead="Scopri alcune delle soluzioni software sviluppate su misura per i nostri clienti."
            />

            <div className="what-we-do-section alt-servicepage">
                <div className="container">
                    <div className="whatwedo-services">
                        {solutions.map((item) => (
                            <a key={item.href} href={item.href}>
                                <p>
                                    <span className="service-icon">{icons[item.icon]}</span>
                                    <span>{item.label}</span>
                                </p>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Solutions;
